import React, { useState } from 'react';
import { ChartBarIcon, Cog6ToothIcon, PlusIcon, PhoneIcon } from '@heroicons/react/24/outline';
import Tabs from '../../components/UI/Tabs';
import Button from '../../components/UI/Button';
import PhoneHealthTab from './components/PhoneHealthTab';
import ManageNumbersTab from './components/ManageNumbersTab';
import PurchaseNumberModal from './components/PurchaseNumberModal';

const TABS = [
  { id: 'health', label: 'Health Monitor', icon: ChartBarIcon },
  { id: 'manage', label: 'Manage Numbers', icon: Cog6ToothIcon },
];

const PhoneNumbersPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('health');
  const [purchaseOpen, setPurchaseOpen] = useState(false);

  return (
    <div className="min-h-full bg-gradient-to-br from-slate-50/80 via-background to-emerald-50/30 dark:from-background dark:via-background dark:to-background">
      <div className="space-y-6 p-4 md:p-6 lg:p-8 max-w-[1600px] mx-auto">
        {/* Page hero */}
        <div className="rounded-2xl border border-border/70 bg-card/90 backdrop-blur-sm shadow-sm p-5 md:p-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">
            <div className="flex items-start gap-4">
              <div className="hidden sm:flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-primary to-primary/70 text-primary-foreground shadow-md">
                <PhoneIcon className="h-6 w-6" />
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-foreground">
                  Phone Numbers
                </h1>
                <p className="text-muted-foreground text-sm mt-1.5 max-w-2xl leading-relaxed">
                  Monitor carrier health, warmup limits, and inventory gaps. Manage Telnyx line types,
                  test calls, and purchase replacements — all in one place.
                </p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 shrink-0">
              <Button variant="outlined" onClick={() => setActiveTab('manage')}>
                Sync &amp; Assign
              </Button>
              <Button onClick={() => setPurchaseOpen(true)}>
                <PlusIcon className="h-4 w-4 mr-1.5" />
                Purchase Number
              </Button>
            </div>
          </div>

          <div className="mt-5 pt-5 border-t border-border/60">
            <Tabs tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} variant="pills" />
          </div>
        </div>

        <div role="tabpanel" className="animate-in fade-in duration-300">
          {activeTab === 'health' && <PhoneHealthTab />}
          {activeTab === 'manage' && <ManageNumbersTab />}
        </div>

        <PurchaseNumberModal
          isOpen={purchaseOpen}
          onClose={() => setPurchaseOpen(false)}
          onPurchased={() => setActiveTab('manage')}
        />
      </div>
    </div>
  );
};

export default PhoneNumbersPage;
